export default __webpack_public_path__ + "static/media/sandboxx-stamp-approval.0f278768.png";